"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullTextSearchApi = exports.FullTextSearchApiConst = exports.FullTextSearcherTypes = exports.DeprecatedFullTextSearchFilters = exports.FullTextSearchFilters = exports.FullTextSearchFilterTypeKeys = void 0;
var tslib_1 = require("tslib");
var Search_utils_1 = require("../Search.utils");
var SearchBaseApi_1 = require("../SearchBaseApi");
var FullTextSearchFilterTypeKeys;
(function (FullTextSearchFilterTypeKeys) {
    FullTextSearchFilterTypeKeys["ALL"] = "";
    FullTextSearchFilterTypeKeys["PRODUCTS"] = "type:products";
    FullTextSearchFilterTypeKeys["DOCUMENTATION"] = "type:documentation";
    FullTextSearchFilterTypeKeys["DRAWINGS"] = "type:drawings";
    FullTextSearchFilterTypeKeys["DOWNLOAD"] = "type:download";
    FullTextSearchFilterTypeKeys["CAREERS"] = "type:careers";
    FullTextSearchFilterTypeKeys["COURSE"] = "type:course";
})(FullTextSearchFilterTypeKeys = exports.FullTextSearchFilterTypeKeys || (exports.FullTextSearchFilterTypeKeys = {}));
var FullTextSearchFilters = /** @class */ (function () {
    function FullTextSearchFilters() {
    }
    FullTextSearchFilters.TypeFilterId = 'type';
    FullTextSearchFilters.TypeFilterAlias = 'type';
    // ALL RESULTS FILTERS //
    FullTextSearchFilters.AllSegmentFilterId = 'all_segment';
    FullTextSearchFilters.AllSegmentFilterAlias = 'allSegment';
    // PRODUCTS FILTERS //
    FullTextSearchFilters.ProductsSegmentFilterId = 'products_segment';
    FullTextSearchFilters.ProductsSegmentFilterAlias = 'productsSegment';
    // DOCUMENTATION FILTERS //
    FullTextSearchFilters.DocumentationSegmentFilterId = 'documentation_segment';
    FullTextSearchFilters.DocumentationSegmentFilterAlias = 'documentationSegment';
    FullTextSearchFilters.DocumentationDocumentTypeFilterId = 'documentation_document_type';
    FullTextSearchFilters.DocumentationDocumentTypeFilterAlias = 'documentationDocumentType';
    FullTextSearchFilters.DocumentationApprovalTypeFilterId = 'documentation_approval_type';
    FullTextSearchFilters.DocumentationApprovalTypeFilterAlias = 'documentationApprovalType';
    FullTextSearchFilters.DocumentationLanguageFilterId = 'documentation_language';
    FullTextSearchFilters.DocumentationLanguageFilterAlias = 'documentationLanguage';
    FullTextSearchFilters.DocumentationCountryFilterId = 'documentation_country';
    FullTextSearchFilters.DocumentationCountryFilterAlias = 'documentationCountry';
    FullTextSearchFilters.DocumentationHierarchyFilterId = 'documentation_path_hierarchy';
    FullTextSearchFilters.DocumentationHierarchyFilterAlias = 'documentationHierarchy';
    FullTextSearchFilters.DocumentationProductHierarchyFilterId = 'documentation_path_hierarchy_product';
    FullTextSearchFilters.DocumentationProductHierarchyFilterAlias = 'documentationProductHierarchy';
    FullTextSearchFilters.DocumentationProductGroupFilterId = 'documentation_product_group';
    FullTextSearchFilters.DocumentationProductGroupFilterAlias = 'documentationProductGroup';
    FullTextSearchFilters.DocumentationProductSeriesFilterId = 'documentation_product_series';
    FullTextSearchFilters.DocumentationProductSeriesFilterAlias = 'documentationProductSeries';
    FullTextSearchFilters.DocumentationAuthorityFilterId = 'documentation_authority';
    FullTextSearchFilters.DocumentationAuthorityFilterAlias = 'documentationAuthority';
    FullTextSearchFilters.DocumentationArchivedFilterId = 'documentation_archived';
    FullTextSearchFilters.DocumentationArchivedFilterAlias = 'documentationArchived';
    FullTextSearchFilters.DocumentationProductionSiteId = 'documentation_production_site';
    FullTextSearchFilters.DocumentationProductionSiteAlias = 'documentationProductionSite';
    // DOWNLOAD FILTERS //
    FullTextSearchFilters.DownloadSegmentFilterId = 'download_segment';
    FullTextSearchFilters.DownloadSegmentFilterAlias = 'downloadSegment';
    FullTextSearchFilters.DownloadSoftwareTypeFilterId = 'download_software_type';
    FullTextSearchFilters.DownloadSoftwareTypeFilterAlias = 'downloadSoftwareType';
    FullTextSearchFilters.DownloadSoftwareCharacteristicFilterId = 'download_software_characteristic';
    FullTextSearchFilters.DownloadSoftwareCharacteristicFilterAlias = 'downloadSoftwareCharacteristic';
    FullTextSearchFilters.DownloadProductGroupFilterId = 'download_product_group';
    FullTextSearchFilters.DownloadProductGroupFilterAlias = 'downloadProductGroup';
    FullTextSearchFilters.DownloadProductSeriesFilterId = 'download_product_series';
    FullTextSearchFilters.DownloadProductSeriesFilterAlias = 'downloadProductSeries';
    // CAREERS FILTERS //
    FullTextSearchFilters.CareersSegmentFilterId = 'careers_segment';
    FullTextSearchFilters.CareersSegmentFilterAlias = 'careersSegment';
    FullTextSearchFilters.CareersCountryFilterId = 'careers_country';
    FullTextSearchFilters.CareersCountryFilterAlias = 'careersCountry';
    FullTextSearchFilters.CareersLocationFilterId = 'careers_location';
    FullTextSearchFilters.CareersLocationFilterAlias = 'careersLocation';
    FullTextSearchFilters.CareersExperienceLevelFilterId = 'careers_experience_level';
    FullTextSearchFilters.CareersExperienceLevelFilterAlias = 'careersExperienceLevel';
    // COURSE FILTERS //
    FullTextSearchFilters.CourseHierarchyFilterId = 'course_path_hierarchy';
    FullTextSearchFilters.CourseHierarchyFilterAlias = 'courseHierarchy';
    FullTextSearchFilters.CourseLanguageFilterId = 'course_language';
    FullTextSearchFilters.CourseLanguageFilterAlias = 'courseLanguage';
    FullTextSearchFilters.CourseSegmentFilterId = 'course_segment';
    FullTextSearchFilters.CourseSegmentFilterAlias = 'courseSegment';
    FullTextSearchFilters.CourseLearningEventTypeFilterId = 'course_learning_type';
    FullTextSearchFilters.CourseLearningEventTypeFilterAlias = 'courseLearningEventType';
    FullTextSearchFilters.CourseDeliveryTypesFilterId = 'course_delivery_types';
    FullTextSearchFilters.CourseDeliveryTypesFilterAlias = 'courseDeliveryTypes';
    FullTextSearchFilters.CareersJobAreaFilterId = 'careers_job_area';
    FullTextSearchFilters.CareersJobAreaFilterAlias = 'careersJobArea';
    // DRAWINGS FILTERS //
    FullTextSearchFilters.DrawingsSegmentFilterId = 'drawings_segment';
    FullTextSearchFilters.DrawingsSegmentFilterAlias = 'drawingsSegment';
    FullTextSearchFilters.DrawingsDrawingTypeFilterId = 'drawings_drawing_type';
    FullTextSearchFilters.DrawingsDrawingTypeFilterAlias = 'drawingsDrawingType';
    FullTextSearchFilters.DrawingsLanguageFilterId = 'drawings_language';
    FullTextSearchFilters.DrawingsLanguageFilterAlias = 'drawingsLanguage';
    FullTextSearchFilters.DrawingsArchivedFilterId = 'drawings_archived';
    FullTextSearchFilters.DrawingsArchivedFilterAlias = 'drawingsArchived';
    FullTextSearchFilters.DrawingsProductGroupFilterId = 'drawings_product_group';
    FullTextSearchFilters.DrawingsProductGroupFilterAlias = 'drawingsProductGroup';
    FullTextSearchFilters.DrawingsProductSeriesFilterId = 'drawings_product_series';
    FullTextSearchFilters.DrawingsProductSeriesFilterAlias = 'drawingsProductSeries';
    FullTextSearchFilters.DrawingsProductHierarchyFilterId = 'drawings_path_hierarchy_product';
    FullTextSearchFilters.DrawingsProductHierarchyFilterAlias = 'drawingsProductHierarchy';
    return FullTextSearchFilters;
}());
exports.FullTextSearchFilters = FullTextSearchFilters;
// DEPRECATED FILTERS ARE SUPPORTED TO REDIRECT USER TO CORRECT QUERY //
//
var DeprecatedFullTextSearchFilters = /** @class */ (function () {
    function DeprecatedFullTextSearchFilters() {
    }
    DeprecatedFullTextSearchFilters.HierarchyFilterId = 'path_hierarchy';
    DeprecatedFullTextSearchFilters.HierarchyFilterAlias = 'hierarchy';
    DeprecatedFullTextSearchFilters.LanguageFilterId = 'language';
    DeprecatedFullTextSearchFilters.LanguageFilterAlias = 'language';
    DeprecatedFullTextSearchFilters.DocumentTypeFilterId = 'document_type';
    DeprecatedFullTextSearchFilters.DocumentTypeFilterAlias = 'documentType';
    DeprecatedFullTextSearchFilters.ProductGroupFilterId = 'product_group';
    DeprecatedFullTextSearchFilters.ProductGroupFilterAlias = 'productGroup';
    DeprecatedFullTextSearchFilters.ProductTypeFilterId = 'product_type';
    DeprecatedFullTextSearchFilters.ProductTypeFilterAlias = 'productType';
    DeprecatedFullTextSearchFilters.ProductFamilyFilterId = 'product_family';
    DeprecatedFullTextSearchFilters.ProductFamilyFilterAlias = 'productFamily';
    DeprecatedFullTextSearchFilters.ProductSeriesFilterId = 'product_series';
    DeprecatedFullTextSearchFilters.ProductSeriesFilterAlias = 'productSeries';
    DeprecatedFullTextSearchFilters.SegmentFilterId = 'segment';
    DeprecatedFullTextSearchFilters.SegmentFilterAlias = 'segment';
    DeprecatedFullTextSearchFilters.ArchivedFilterId = 'archived';
    DeprecatedFullTextSearchFilters.ArchivedFilterAlias = 'archived';
    DeprecatedFullTextSearchFilters.LocationFilterId = 'location';
    DeprecatedFullTextSearchFilters.LocationFilterAlias = 'location';
    DeprecatedFullTextSearchFilters.JobAreaFilterId = 'job_area';
    DeprecatedFullTextSearchFilters.JobAreaFilterAlias = 'jobArea';
    DeprecatedFullTextSearchFilters.PositionTypeFilterId = 'position_type';
    DeprecatedFullTextSearchFilters.PositionTypeFilterAlias = 'positionType';
    DeprecatedFullTextSearchFilters.AuthorityFilterId = 'authority';
    DeprecatedFullTextSearchFilters.AuthorityFilterAlias = 'authority';
    return DeprecatedFullTextSearchFilters;
}());
exports.DeprecatedFullTextSearchFilters = DeprecatedFullTextSearchFilters;
var FullTextSearcherTypes;
(function (FullTextSearcherTypes) {
    FullTextSearcherTypes["Product"] = "product";
    FullTextSearcherTypes["ProductExternal"] = "productExternalContent";
    FullTextSearcherTypes["ProductCategory"] = "productCategory";
    FullTextSearcherTypes["ProductSubCategory"] = "productSubCategory";
    FullTextSearcherTypes["Download"] = "download";
    FullTextSearcherTypes["DownloadPage"] = "downloadPage";
    FullTextSearcherTypes["Drawings"] = "drawings";
    FullTextSearcherTypes["Documentation"] = "documentation";
    FullTextSearcherTypes["Careers"] = "careers";
    FullTextSearcherTypes["Course"] = "course";
    FullTextSearcherTypes["Products"] = "products";
    FullTextSearcherTypes["Event"] = "event";
    FullTextSearcherTypes["EventExternal"] = "eventExternalContent";
    FullTextSearcherTypes["Article"] = "articlePage";
    FullTextSearcherTypes["All"] = "all";
})(FullTextSearcherTypes = exports.FullTextSearcherTypes || (exports.FullTextSearcherTypes = {}));
var FullTextSearchApiConst;
(function (FullTextSearchApiConst) {
    FullTextSearchApiConst["ALL_LANGUAGES"] = "all";
    FullTextSearchApiConst["ALL_ARCHIVED_OPTIONS"] = "all";
})(FullTextSearchApiConst = exports.FullTextSearchApiConst || (exports.FullTextSearchApiConst = {}));
// tslint:disable-next-line
var FullTextSearchApi = /** @class */ (function (_super) {
    tslib_1.__extends(FullTextSearchApi, _super);
    function FullTextSearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullTextSearchApi.prototype.buildQuery = function (params) {
        var builder = new Search_utils_1.SearchParamsBuilder();
        // COMMON PARAMS //
        builder.Append('q', params.query || '*');
        builder.Append('initial_search', params.isInitialSearch ? params.isInitialSearch : undefined);
        builder.Append('lang', params.language ? params.language.toLowerCase() : params.language);
        builder.Append('country', params.country ? params.country.toLowerCase() : params.country);
        builder.Append('hits', params.pageSize);
        builder.Append('offset', params.offset);
        builder.Append('sort', params.sort);
        // TYPE FILTER //
        builder.AppendArray('facet_type', params.types ? params.types.slice(0, 1) : undefined);
        // ALL RESULTS FILTERS PARAMS //
        builder.Append('facet_all_segment', params.allSegment);
        // PRODUCTS FILTERS PARAMS //
        builder.Append('facet_products_segment', params.productsSegment);
        // DOCUMENTATION FILTERS PARAMS //
        builder.Append('facet_documentation_segment', params.documentationSegment);
        builder.AppendArray('facet_documentation_document_type', params.documentationDocumentTypes);
        builder.AppendArray('facet_documentation_approval_type', params.documentationApprovalTypes);
        builder.AppendArray('facet_documentation_language', params.documentationLanguageTypes &&
            params.documentationLanguageTypes.length &&
            params.documentationLanguageTypes[0] !== FullTextSearchApiConst.ALL_LANGUAGES
            ? params.documentationLanguageTypes
            : undefined);
        builder.Append('facet_documentation_country', params.documentationCountryFilter);
        builder.Append('facet_documentation_path_hierarchy', params.documentationHierarchy);
        builder.Append('facet_documentation_path_hierarchy_product', params.documentationProductHierarchy);
        builder.Append('facet_documentation_product_group', params.documentationProductGroup);
        builder.Append('facet_documentation_product_series', params.documentationProductSeries);
        builder.Append('facet_documentation_authority', params.documentationAuthorityFilter);
        builder.Append('facet_documentation_archived', params.documentationArchived !== FullTextSearchApiConst.ALL_ARCHIVED_OPTIONS
            ? params.documentationArchived
            : undefined);
        builder.AppendArray('facet_documentation_production_site', params.documentationProductionSite);
        // DOWNLOAD FILTERS PARAMS //
        builder.Append('facet_download_segment', params.downloadSegment);
        builder.AppendArray('facet_download_software_type', params.downloadSoftwareType);
        builder.AppendArray('facet_download_software_characteristic', params.downloadSoftwareCharacteristic);
        builder.Append('facet_download_product_group', params.downloadProductGroup);
        builder.Append('facet_download_product_series', params.downloadProductSeries);
        // CAREERS FILTERS PARAMS //
        builder.Append('facet_careers_segment', params.careersSegment);
        builder.Append('facet_careers_country', params.careersCountryFilter);
        builder.Append('facet_careers_location', params.careersLocation);
        builder.Append('facet_careers_job_area', params.careersJobArea);
        builder.AppendArray('facet_careers_experience_level', params.careersExperienceLevel);
        // COURSE FILTERS PARAMS //
        builder.Append('facet_course_segment', params.courseSegment);
        builder.Append('facet_course_learning_type', params.courseLearningEventType);
        builder.AppendArray('facet_course_delivery_types', params.courseDeliveryTypes && params.courseDeliveryTypes.length
            ? params.courseDeliveryTypes
            : undefined);
        builder.AppendArray('facet_course_language', params.courseLanguageTypes &&
            params.courseLanguageTypes.length &&
            params.courseLanguageTypes[0] !== FullTextSearchApiConst.ALL_LANGUAGES
            ? params.courseLanguageTypes
            : undefined);
        builder.Append('facet_course_path_hierarchy', params.courseHierarchy);
        // DRAWINGS FILTERS PARAMS //
        builder.Append('facet_drawings_segment', params.drawingsSegment);
        builder.AppendArray('facet_drawings_drawing_type', params.drawingsDrawingTypes);
        builder.AppendArray('facet_drawings_language', params.drawingsLanguageTypes &&
            params.drawingsLanguageTypes.length &&
            params.drawingsLanguageTypes[0] !== FullTextSearchApiConst.ALL_LANGUAGES
            ? params.drawingsLanguageTypes
            : undefined);
        builder.Append('facet_drawings_path_hierarchy_product', params.drawingsProductHierarchy);
        builder.Append('facet_drawings_product_group', params.drawingsProductGroup);
        builder.Append('facet_drawings_product_series', params.drawingsProductSeries);
        builder.Append('facet_drawings_archived', params.drawingsArchived !== FullTextSearchApiConst.ALL_ARCHIVED_OPTIONS
            ? params.drawingsArchived
            : undefined);
        // DEPRECATED FILTERS PARAMS //
        //
        builder.Append('facet_segment', params.segment);
        builder.AppendArray('facet_language', params.languageTypes &&
            params.languageTypes.length &&
            params.languageTypes[0] !== FullTextSearchApiConst.ALL_LANGUAGES
            ? params.languageTypes
            : undefined);
        builder.Append('facet_path_hierarchy', params.hierarchy);
        builder.Append('facet_archived', params.archived !== FullTextSearchApiConst.ALL_ARCHIVED_OPTIONS ? params.archived : undefined);
        builder.Append('facet_product_group', params.productGroup);
        builder.Append('facet_product_series', params.productSeries);
        builder.Append('facet_product_family', params.productFamily);
        builder.Append('facet_product_type', params.productType);
        builder.AppendArray('facet_document_type', params.documentTypes);
        builder.Append('facet_location', params.location);
        builder.Append('facet_job_area', params.jobArea);
        builder.Append('facet_position_type', params.positionType);
        builder.Append('facet_authority', params.authorityFilter);
        return builder.toString();
    };
    return FullTextSearchApi;
}(SearchBaseApi_1.SearchBaseApi));
exports.FullTextSearchApi = FullTextSearchApi;
